/* eslint-disable */
import React from 'react'
import './Header.scss'
import LoggedoutProfileDropdown from './LoggedoutProfileDropdown'
import LoggedinProfileDropdown from './LoggedinProfileDropdown'
import { checkUserLogin } from 'AccountsUtils'
import { checkMobileDevice } from './../../../utils/validator'
import { isInDomain, isInFlyinDomain } from 'AccountsUtils'
import { getMappedValue } from '../../../utils/arabicUtils'

import { getCookie } from 'AccountsUtils'

class Header extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      username: '',
      isSignedin: false,
      isMobile: window.innerWidth <= 768
    }
  }

  componentDidMount() {
    window.addEventListener('resize', this.handleResize)
    let username
    let isSignedin
    const userId = unescape(this.getCookie('userid'))
    try {
      if (userId) {
        username = userId.split('|')[0]
        if (username === 'null' || username === '') {
          username = 'My account'
        }
        isSignedin = true
      } else {
        username = 'Your Trips'
        isSignedin = false
      }
    } catch (e) {
      username = 'Your Trips'
      isSignedin = false
    }
    this.setState({
      username,
      isSignedin
    })
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize)
  }

  handleResize = () => {
    this.setState({
      isMobile: window.innerWidth <= 768
    })
  }

  getCookie = cname => {
    var name = cname + '='
    var ca = document.cookie.split(';')
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i]
      while (c.charAt(0) === ' ') {
        c = c.substring(1)
      }
      if (c.indexOf(name) === 0) {
        return c.substring(name.length, c.length)
      }
    }
    return ''
  }

  deleteCookie = name => {
    document.cookie =
      name +
      '=;expires=Thu, 01 Jan 1970 00:00:01 GMT;path=/;domain=qa2.cleartrip.ae'
    document.cookie =
      name +
      '=;expires=Thu, 01 Jan 1970 00:00:01 GMT;path=/;domain=.cleartrip.ae'
    document.cookie =
      name +
      '=;expires=Thu, 01 Jan 1970 00:00:01 GMT;path=/;domain=cleartrip.ae'
    document.cookie =
      name +
      '=;expires=Thu, 01 Jan 1970 00:00:01 GMT;path=/;domain=qa2.cleartrip.ae'
  }

  showProfileDropdown = e => {
    console.log('showProfileDropdown')
    e.stopPropagation()
    this.setState({
      isProfileDropdownShown: true
    })
  }

  hideProfileDropdown = () => {
    console.log('hideProfileDropdown')
    setTimeout(() => {
      this.setState({
        isProfileDropdownShown: false
      })
    }, 100)
  }

  showCountryDropdown = e => {
    e.stopPropagation()
    this.setState({
      isCountryDropdownShown: true
    })
  }

  hideCountryDropdown = () => {
    setTimeout(() => {
      this.setState({
        isCountryDropdownShown: false
      })
    }, 100)
  }

  logout = () => {
    this.deleteCookie('userid')
    window.localStorage.removeItem('ON_LOGIN_PUSH')
    window.location.href = '/signout'
  }
  
  handleBackClick = () => {
    if (window.history && window.history.length > 1) {
      window.history.back()
    } else {
      window.location.href = '/'
    }
  }

  renderFlyinHeader = () => {
    const { isMobile, isSignedin, username } = this.state

    const usrStrng = username.includes('%40')
      ? decodeURIComponent(username.split('%257C')[0].replace('%40', '@'))
      : username
    const disName = usrStrng.includes('|') ? usrStrng.split('|')[0] : usrStrng
    const displayName = disName ? disName : 'Guest User'
    const lng = this.getCookie('selectedLanguage')

    return (
      <header>
        <div
          className="ctProducts flex container"
          style={{
            backgroundColor: '#fff',
            height: '60px',
            padding: '8px 0',
            width: '60%',
            margin: '0 auto',
            display: 'flex',
            justifyContent: checkMobileDevice() ? 'center' : 'initial',
            borderBottom: '1px solid #CAD6E3',
            position: 'relative'
          }}
        >
          {checkMobileDevice() && (
            <div
              className="back-button-container"
              style={{ 
                padding: '10px 16px', 
                cursor: 'pointer',
                position: 'absolute',
                left: '0',
                display: 'flex',
                alignItems: 'center',
                zIndex: 10
              }}
              onClick={this.handleBackClick}
            >
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M15 18L9 12L15 6"
                  stroke="#4A4A4A"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </div>
          )}
          <div className="flex flex-middle justify-between items-center w-full">
            <div className="flex flex-middle">
              <div className="flex items-center">
                <a href="/">
                  <img
                    src="https://ui.cltp.co/flyinstatic/common/themes/v1/images/flyinLogo.png"
                    alt="Flyin_logo"
                    style={{ height: '32px' }}
                  />
                </a>
              </div>
              {checkMobileDevice() ? (
                <></>
              ) : (
                <>
                  <div class="col-1"></div>
                  <nav className="flex items-center ml-16">
                    <a
                      href={`/${lng}/flights`}
                      className="hover:text-gray-200 px-6 text-base font-medium"
                      style={{
                        textDecoration: 'none',
                        color: 'darkslategrey',
                        fontSize: '16px',
                        fontWeight: '700'
                      }}
                    >
                      {getMappedValue('Flights')}
                    </a>
                    <a
                      href={`/${lng}/hotels`}
                      className=" hover:text-gray-200 px-6 text-base font-medium"
                      style={{
                        textDecoration: 'none',
                        color: 'darkslategrey',
                        fontSize: '16px',
                        fontWeight: '700'
                      }}
                    >
                      {getMappedValue('Hotels')}
                    </a>
                    <a
                      href={`/${lng}/flight-hotel`}
                      className="hover:text-gray-200 px-6 text-base font-medium"
                      style={{
                        textDecoration: 'none',
                        color: 'darkslategrey',
                        fontSize: '16px',
                        whiteSpace: 'nowrap',
                        fontWeight: '700'
                      }}
                    >
                      {getMappedValue('Flight + Hotel')}
                    </a>
                  </nav>
                  <div
                    style={{
                      color: 'black',
                      marginLeft: '16vw',
                      fontSize: '14px',
                      fontWeight: '500'
                    }}
                  >
                    {displayName}
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </header>
    )
  }

  renderCleartripHeader = () => {
    const { isSignedin, isProfileDropdownShown, username } = this.state

    return (
      <header className="global-header">
        <section id="GlobalNav" className="ctGlobalNav global-nav-v3">
          <div
            className="flex flex-start flex-between"
            style={{ 
              margin: '0 auto', 
              maxWidth: 1140,
            }}
          >
            <div className="ctProducts flex">
              <If condition={isInDomain()}>
                <div className="flex flex-middle">
                  <a
                    data-test-attrib="cleartrip-logo"
                    href="/"
                    className="mr-6"
                  >
                    <svg
                      width="107"
                      height="24"
                      viewBox="0 0 310 65"
                      fill="none"
                      color="#214497"
                      className="mr-7"
                    >
                      {/* ... (keep existing SVG paths) ... */}
                    </svg>
                  </a>
                </div>
                <Else />
                <a className="ctBrand" href={'/'}>
                  <span
                    className="header-logo cleartrip-logo mt-2"
                    title="Cleartrip account"
                  >
                    Home
                  </span>
                  <span
                    className="header-logo account-logo mt-5 ml-1 mr-3"
                    title="Account"
                  >
                    Account
                  </span>
                </a>
              </If>

              <a className="border-table" href="/flights">
                <span className="header-logo flights-logo m-2" title="Flights">
                  Flights
                </span>
              </a>
              <a className="border-table" href="/hotels">
                <span className="header-logo hotels-logo m-2" title="Hotels">
                  Hotels
                </span>
              </a>
            </div>
            <div id="userAccountNav">
              <nav className="ctMainMenu">
                <ul>
                  <li
                    className="menuItem listMenuContainer userAccountMenuContainer"
                    onClick={this.showProfileDropdown}
                    tabIndex="2"
                  >
                    <a
                      className="listMenuLink userAccountLink"
                      id="userAccountLink"
                    >
                      <span className="avatar man_24" />
                      <span className="span span19 truncate">{username}</span>
                    </a>
                    {!isSignedin && isProfileDropdownShown && (
                      <LoggedoutProfileDropdown
                        hideProfileDropdown={this.hideProfileDropdown}
                      />
                    )}
                    {isSignedin && isProfileDropdownShown && (
                      <LoggedinProfileDropdown
                        logout={this.logout}
                        hideProfileDropdown={this.hideProfileDropdown}
                      />
                    )}
                  </li>
                </ul>
              </nav>
            </div>
          </div>
        </section>
      </header>
    )
  }

  render() {
    return isInFlyinDomain()
      ? this.renderFlyinHeader()
      : this.renderCleartripHeader()
  }
}

export default Header